// 🔒
import { Outlet } from "react-router";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToHash from "./components/ScrollToHash";

export default function MainLayout() {
  return (
    <div className="app-shell">
      <ScrollToHash />
      <Navbar />

      <main>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
// 🔒